import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { adminMatchGuard } from './core/navigation/admin-match.guard';


const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./auth/auth.module').then((module) => module.AuthModule),
  },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((module) => module.DashboardModule),
  },
  {
    path: 'cursos',
    loadChildren: () =>
      import('./courses/courses.module').then((m) => m.CoursesModule),
  },
  {
    path: 'meus-cursos',
    loadChildren: () =>
      import('./courses/courses.module').then((m) => m.CoursesModule),
  },
  {
    path: 'catalogo/cursos',
    loadChildren: () =>
      import('./courses/courses.module').then((m) => m.CoursesModule),
  },
  {
    path: 'catalogo/trilhas',
    loadChildren: () =>
      import('./trails/trails.module').then((m) => m.TrailsModule),
  },
  {
    path: 'minhas-trilhas',
    loadChildren: () =>
      import('./trails/trails.module').then((m) => m.TrailsModule),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canMatch: [adminMatchGuard],
    data: {
      breadcrumb: 'Administração',
    },
  },
  {
    path: 'meus-certificados',
    loadComponent: () =>
      import('./certificates/student-certificate-list/student-certificate-list.component')
        .then((m) => m.StudentCertificateListComponent),
    data: {
      showContentHeader: true,
      title: 'Meus Certificados',
      subtitle: 'Visualize e baixe seus certificados de conclusão.',
      contentsPath: [{ name: 'Meus Certificados', path: '/meus-certificados' }],
    },
  },
  {
    path: 'certificados',
    loadChildren: () =>
      import('./certificates/certificates.module').then((m) => m.CertificatesModule),
  },
  {
    path: 'meu-certificado',
    loadChildren: () =>
      import('./certificates/certificates.module').then((m) => m.CertificatesModule),
  },
  {
    path: 'meus-chats',
    loadComponent: () =>
      import('./chats/chat-page/chat-page.component')
        .then((m) => m.ChatPageComponent),
    data: {
      showContentHeader: true,
      title: 'Meus Chats',
      subtitle: 'Converse com instrutores dos seus cursos.',
      contentsPath: [{ name: 'Meus Chats', path: '/meus-chats' }],
    },
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }